// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {CustomerTypeFacet} from './customer-type-facet';
import {KeyValueList} from '../../key-value-list';

export const FacetOptions = t.struct({
    cities: t.Array,
    cityAsDropdown: t.Boolean,
    cityLabel: t.maybe(t.String),
    countries: KeyValueList,
    customerTypes: t.list(CustomerTypeFacet),
    postalCodeLabel: t.maybe(t.String),
    states: KeyValueList,
    statesLabel: t.maybe(t.String),
    useTaxId: t.Boolean
}, {
    defaultProps: {
        cities: [],
        cityAsDropdown: false,
        cityLabel: 'City',
        countries: [],
        customerTypes: [],
        postalCodeLabel: 'Postal Code',
        states: [],
        statesLabel: 'States',
        useTaxId: false
    },
    name: 'Facets',
    strict: true
});
